function fetchConfig(type = "json") {
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: `application/${type}`,
        },
    };
}




class Cart {
    fetchData() {  

        const updateCart = (data) => {
            const parsedData = JSON.parse(data);
            const objectValue = parsedData["slide-cart"];
            const cartInner = new DOMParser().parseFromString(objectValue,"text/html");          
            let updateCartHTML = cartInner.getElementById("slide-cart").innerHTML;
               console.log(updateCartHTML)          
            document.querySelectorAll(".cart-preview").forEach(function(element) {
    element.innerHTML = updateCartHTML;
if (!document.body.classList.contains('drawer-open')) {
    document.body.classList.add('drawer-open');
}

});

        };       
            fetch("/?sections=slide-cart")
                .then((response) => response.text())
                .then((data) => updateCart(data));
 
    }
}

class CartDrawer extends HTMLElement {
    constructor() {
        super();
        //this.initEventListeners();
    }
    connectedCallback() {
        this.observer = new MutationObserver(() => {
            this.initEventListeners();
        });
        this.observer.observe(this, {
            childList: true,
        });
        this.initEventListeners();
      
    }

    disconnectedCallback() {
        this.observer.disconnect();
    }

    initEventListeners() {
        this.increaseQuantityButtons = this.querySelectorAll(".q-plus");
      console.log(this.increaseQuantityButtons)
        this.decreaseQuantityButtons = this.querySelectorAll(".q-minus");
        this.quantityInputs = this.querySelectorAll(".cart-drawer-qty");

        this.increaseQuantityButtons.forEach((button) => {
            button.addEventListener("click", this.increaseQuantity.bind(this));
        });

        this.decreaseQuantityButtons.forEach((button) => {
            button.addEventListener("click", this.decreaseQuantity.bind(this));
        });

        this.quantityInputs.forEach((input) => {
            input.addEventListener("change", this.manualUpdate.bind(this));
        });
    }

    manualUpdate(event) {
        let AddClass = event.target.closest(".slide-cart-body");
        AddClass.classList.add("ajax-class");

        const input = event.target
            .closest(".qty-box")
            .querySelector(".cart-drawer-qty");
        input.value = parseInt(input.value, 10);
        this.updateQuantity(input);
    }

    increaseQuantity(event) {
           event.preventDefault();

        if (event.target.classList.contains("q-plus")) {

            let AddClass = event.target.closest(".slide-cart-body");
            AddClass.classList.add("ajax-class");

            const input = event.target
                .closest(".qty-box")
                .querySelector(".cart-drawer-qty");
            input.value = parseInt(input.value, 10) + 1;
            this.updateQuantity(input);
        }
    }

    decreaseQuantity(event) {
       event.preventDefault();
        if (event.target.classList.contains("q-minus")) {
            let AddClass = event.target.closest(".slide-cart-body");
            AddClass.classList.add("ajax-class");
            const input = event.target
                .closest(".qty-box")
                .querySelector(".cart-drawer-qty");
            input.value = parseInt(input.value, 10) - 1;
            this.updateQuantity(input);
        }
    }
    updateToCart(data) {
        fetch("/cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            })
            .then(function(response) {               
                if (response.ok) {
                    let cartAjax = new Cart();
                    cartAjax.fetchData();
                } else {
                   let cartAjax = new Cart();
                    cartAjax.fetchData();
                    
                 /* let removeCartClass = document.querySelector(".slide-cart-body");                  
                 removeCartClass.classList.remove("ajax-class"); */
                    
                    //throw new Error("Request was not successful");
                }
            })
            .then(function(item) {})
            .catch(function(error) {});
    }

    updateQuantity(event) {
        const input = event.target;
        const lineItemKey = event.dataset.lineItemKey;
        const VariantId = event.dataset.id;
        const Quantity = event.value;

        const items = {
            id: lineItemKey,
            quantity: Quantity,
        };

        this.updateToCart(items);
    }
}

customElements.define("side-cart", CartDrawer);

class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("click", (event) => {
            event.preventDefault();
            const AddClass = event.target.closest(".cart-detail, .slide-cart-body");
            AddClass.classList.add("ajax-class");
            const variantId = this.querySelector("a")
                .getAttribute("href")
                .split("id=")[1]
                .split("&")[0];
            const items = {
                id: variantId,
                quantity: 0,
            };
           
           const MyMainCart =  new CartDrawer();
            MyMainCart.updateToCart(items);
        });
    }
}

customElements.define("cart-remove-button", CartRemoveButton)